module.exports = __webpack_public_path__ + "img/Technology.f1c31f49.svg";